module.exports = __webpack_public_path__ + "static/img/scroll-spritesheet.b45f7b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/race/scroll-spritesheet.png
// module id = 482
// module chunks = 1